// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Repoarts_PageHolder__33NZV","tabHolder":"Repoarts_tabHolder__-a6KY","onFocus":"Repoarts_onFocus__3nM6Q"};